// import React from 'react';
// import './levels.css'
// import Nav from '../components/layout/nav';
// import Levelcard from '../components/common/levelcard';
// import { useNavigate } from 'react-router-dom';
// import Settings from '../components/layout/Settings';

// const Levels = () => {
//         const navigate = useNavigate();
//     return ( 
        

//             <main className='levels'>
//                 <Nav 
//                 title="LEVELS"
//                 sub="Progress: 0/10 Completed"
//                 />
//                 <section className='lvlgrid'>
//                     <Levelcard 
//                     lock="lvlcard"
//                     number="1"
//                     name="Color Cascade"
//     onClick={() => {
//         console.log('CLICKED');
//         navigate('/level1');
//     }}
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="2"
//                     name="RIDDLE PALS"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="3"
//                     name="Prism Paths"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="4"
//                     name="Neon Maze"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="5"
//                     name="Crystal Quest"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="6"
//                     name="Light Beam"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="7"
//                     name="Spectrum Shift"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="8"
//                     name="Chromatic Chaos"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="9"
//                     name="Glow Grid"
//                     />
//                     <Levelcard 
//                     lock="lockedlvl"
//                     number="10"
//                     name="Prism Master"
//                     />
//                 </section>

//                 <Settings />

//                 <article className='pageinfo'>
//                     <h3>Complete Level 1 to unlock Level 2</h3>
//                     <h3 className='opacity1'>Earn 3 stars in each level for perfect completion</h3>
//                 </article>
//             </main>

//      );
// }
 
// export default Levels;

import React from 'react';
import './levels.css'
import Nav from '../components/layout/nav';
import Levelcard from '../components/common/levelcard';
import { useNavigate } from 'react-router-dom';
import Settings from '../components/layout/Settings';
import { getLevelConfig, LEVEL_CONFIG, TOTAL_LEVELS } from '../utils/levelConfig';
import { useProgress } from '../hooks/useProgress';

const Levels = () => {
    const navigate = useNavigate();
    const { isUnlocked, getStars, completedCount } = useProgress();

    return (
        <main className='levels'>
            <Nav
                title="LEVELS"
                sub={`Progress: ${completedCount}/${TOTAL_LEVELS} Completed`}
            />
            <section className='lvlgrid'>
                {LEVEL_CONFIG.map(({ level, name }) => {
                    const unlocked = isUnlocked(level);
                    return (
                        <Levelcard
                            key={level}
                            lock={unlocked ? 'lvlcard' : 'lockedlvl'}
                            number={String(level)}
                            name={name}
                            earnedStars={getStars(level)}
                            onClick={() => navigate(getLevelConfig(level).path)}
                        />
                    );
                })}
            </section>

            <Settings />

            <article className='pageinfo'>
                <h3>Complete each level to unlock the next</h3>
                <h3 className='opacity1'>Earn 3 stars in each level for perfect completion</h3>
            </article>
        </main>
    );
}

export default Levels;